import { createContextMenuDynamicOptions } from '@components/map/contextMenu/builders/utils';

import { MapIdEnum, OperationalMapId } from '@/types/map.types';
import { MenuItemOption } from '@/types/menu.types';

import { FeatureTypeToContextComponentEnum, MenuBuilder, MenuKey } from '../type';
import {
  buildCreateEventOption,
  buildDisengageOption,
  buildEngageOption,
  buildMeasureOption,
  buildPointCUASOption,
  buildQrCodeOption,
  CommonContextMenuContext,
  HasDisengageContext,
  HasEngageContext,
  HasPointCUASContext,
} from './common';

export type DefaultContextMenuCore = {
  canResetSituation: boolean;
  handleResetSituationClick: () => void;
};

export type DefaultContextMenuContext = CommonContextMenuContext &
  HasPointCUASContext &
  HasEngageContext &
  HasDisengageContext &
  DefaultContextMenuCore;

export type DefaultContextMenuStaticOptions = {
  displayPositionQrCode: boolean;
  measure: boolean;
  createEvent: boolean;
};

export type DefaultContextMenuDynamicOptions = {
  engage: boolean;
  disengage: boolean;
  resetSituation: boolean;
  pointCUAS: boolean;
};

export type DefaultContextMenuOptions = DefaultContextMenuStaticOptions & DefaultContextMenuDynamicOptions;

const DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS: DefaultContextMenuDynamicOptions = {
  pointCUAS: true,
  engage: true,
  disengage: true,
  resetSituation: true,
};

const allTrue = createContextMenuDynamicOptions(DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, true);
const allFalse = createContextMenuDynamicOptions(DEFAULT_CONTEXT_MENU_DYNAMIC_OPTIONS, false);

export const defaultContextMenuConfig: Record<OperationalMapId, DefaultContextMenuDynamicOptions> = {
  [MapIdEnum.LIVE]: allTrue,
  [MapIdEnum.LAD]: allTrue,
  [MapIdEnum.REPLAY]: allFalse,
  [MapIdEnum.STATISTICS]: allFalse,
};

const buildResetSituationOption: MenuBuilder<FeatureTypeToContextComponentEnum.DEFAULT>['build'] = (
  ctx,
): [MenuKey, MenuItemOption] => [
  'resetSituation',
  {
    label: 'contextmenu.actions.resetSituation',
    isHidden: !ctx.canResetSituation,
    onAction: ctx.handleResetSituationClick,
  },
];

export const defaultMenuBuilders: MenuBuilder<FeatureTypeToContextComponentEnum.DEFAULT>[] = [
  {
    order: 1,
    build: buildQrCodeOption,
  },
  {
    order: 2,
    build: buildMeasureOption,
  },
  {
    order: 3,
    build: buildCreateEventOption,
  },
  {
    order: 4,
    separator: true,
  },
  {
    order: 5,
    build: buildEngageOption,
  },
  {
    order: 6,
    build: buildDisengageOption,
  },
  {
    order: 7,
    build: buildResetSituationOption,
  },
  {
    order: 8,
    separator: true,
  },
  {
    order: 9,
    build: buildPointCUASOption,
  },
];
